var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel slide",attrs:{"id":"carouselExampleSlidesOnly","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"carousel-item active"},[_c('lazy-image',{staticClass:"img-fluid img-container lozad",attrs:{"id":"carousel_2","src":"/assets/images/carousel_2.jpg"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }